// src/pages/Profile/components/ProfileLoading.jsx

import React from "react";

export default function ProfileLoading({ backgroundImage }) {
  return (
    <main className="relative min-h-screen overflow-hidden bg-slate-950 text-white">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url("${backgroundImage}")` }}
      />

      <div className="absolute inset-0 bg-slate-950/80" />

      <div className="relative z-10 flex min-h-screen items-center justify-center px-4 pt-[calc(var(--site-navbar-h)+48px)]">
        <div className="w-full max-w-4xl rounded-[2.5rem] border border-white/10 bg-white/10 p-8 shadow-2xl backdrop-blur-2xl">
          <div className="mx-auto h-28 w-28 animate-pulse rounded-full bg-white/20" />
          <div className="mx-auto mt-6 h-8 w-64 animate-pulse rounded-full bg-white/20" />
          <div className="mx-auto mt-4 h-5 w-80 animate-pulse rounded-full bg-white/10" />
        </div>
      </div>
    </main>
  );
}